module.exports = __webpack_public_path__ + "img/1.9eb45e7a.png";